/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BiometricEnrolResponseDTO = {
    attestationStatus?: BiometricEnrolResponseDTO.attestationStatus;
    credentialId?: string;
    securityLevel?: BiometricEnrolResponseDTO.securityLevel;
};

export namespace BiometricEnrolResponseDTO {

    export enum attestationStatus {
        NONE = 'NONE',
        RECORDED = 'RECORDED',
        VERIFIED = 'VERIFIED',
        REJECTED = 'REJECTED',
    }

    export enum securityLevel {
        SOFTWARE = 'SOFTWARE',
        TEE = 'TEE',
        STRONGBOX = 'STRONGBOX',
    }


}
